<template>
	<div id="notification-results" class="container panel" v-tooltip-container>
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" title="Notifications" subtitle="Password Security Portal"></dash-head>		

				<table-actions placeholder="search results" @search-changed="searchChanged" hideEdit="true" hideDelete="true">
				</table-actions>

				<error :error="error"></error>

				<table-view id="notification-results">
					<table-row slot="header">
						<table-header @click-header="sortByDate" sort="descending">Date</table-header>
						<table-header @click-header="sortByDomain" sort="none">Domain</table-header>
        				<table-header @click-header="sortByEmail" sort="none">Email</table-header>
        				<table-header @click-header="sortBySource" sort="none">Source</table-header>
        				<table-header @click-header="sortByType" sort="none">Type</table-header>
					</table-row>
					<table-row v-if="loading" slot="body">
						<td colspan="5" class="spinner"><div><span></span></div></td>
					</table-row>
					<table-row slot="body" v-for="result in results" :key="result.rowkey">
						<table-cell>{{result.date.toLocaleDateString()}}</table-cell>
						<table-cell><a :href="'#/domain/' + result.domain">{{result.domain}}</a></table-cell>
						<table-cell><a :href="'#/email/' + result.email">{{result.email}}</a></table-cell>
						<table-cell><source-tooltip :source="result.source"></source-tooltip></table-cell>
						<table-cell>{{result.typeText}}</table-cell>
					</table-row>
				</table-view>

				<div class="row">
					<div class="col-md-6">
						<table-pagination :page="page" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
					</div>
					<div class="col-md-6">
						<div class="text-right">
						</div>
					</div>
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'
	import SourceTooltip from './SourceTooltip'
	import Error from './Error'

	import api from '../api'
	import router from '../router'

	export default {
		name: 'NotificationsPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination, SourceTooltip, Error},
		data() {
			return {
				data: null,
				error: null,
				loading: true,
				search: '',
				page:1
			}
		},
		computed: {
			filteredData() {
				if (!this.data) return [];
				if (!this.search) return this.data;
				return this.data.filter(value => value.email.includes(this.search));
			},
			totalRows() {
				return this.filteredData.length;
			},
			results() {
				const start = (this.page-1) * this.pageSize;					
				const sliced = [];								

				for (var result of this.filteredData.slice(start, start + this.pageSize)) {						
					result.typeText = (result.type === 'NewPassword') ? 'New Password': result.type;
					sliced.push(result);
				}
				
				return sliced;
			}
		},
		methods: {
			sortByDate(direction) {
				this.sortByPropertyNumeric(direction, 'date');				
			},
			sortByDomain(direction) {
				this.sortByProperty(direction, 'domain');
			},
			sortByEmail(direction) {
				this.sortByProperty(direction, 'email');
			},
			sortBySource(direction) {
				this.sortByProperty(direction, 'source');
			},
			sortByType(direction) {
				this.sortByProperty(direction, 'type');
			},
			sortByProperty(direction, name) {		
				if (direction === 'ascending') {
					this.data.sort(function (a,b) {
						if (a[name] === b[name]) return 0;
						return (a[name] > b[name]) ? 1 : -1;
					});
				}
				else {
					this.data.sort(function (a,b) {
						if (b[name] === a[name]) return 0;
						return (b[name] > a[name]) ? 1 : -1;
					});

				}
				this.page = 1;
			},
			sortByPropertyNumeric(direction, name) {				
				if (direction === 'ascending') {
					this.data.sort((a,b) => a[name] - b[name]);
				}
				else {					
					this.data.sort((a,b) => b[name] - a[name]);
				}
				this.page = 1;
			},
			searchChanged(value) {
				this.search = value.toLowerCase();
				this.page = 1;
			},
			pageChanged(value) {
				this.page = value;
			}
		},
		async mounted() {
			try
			{
				const response = await api.get('notifications');					
				this.data = response.data;

				//Loop through all data and work out derived values
				for (var result of this.data) {
					const rk = result.rowKey;
					result.date = new Date(`${rk.substring(0,4)}-${rk.substring(4,6)}-${rk.substring(6,8)}`); //201809171517058231

					const splits = result.email.split('@');
					result.domain = splits[1];
				}

				//Sort all the data
				this.sortByDate('date', 'descending');
				this.page = 1;
			}
			catch(err) {			
				this.error = err;
			}
			finally {
				this.loading = false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/NotificationsPanel.vue